// @ts-nocheck
// Constants — path, languages, stats, counsellor profile.

export const PATH = [
  { id: "boards", label: "Boards", step: 1 },
  { id: "neet", label: "NEET", step: 2 },
  { id: "jee", label: "JEE", step: 3 },
  { id: "olymp", label: "Olympiad", step: 4 },
];

export const LANGUAGES = [
  "Hindi", "Telugu", "Tamil", "Kannada", "Malayalam",
  "Marathi", "Bengali", "Gujarati", "Punjabi", "Urdu",
  "Odia", "English",
];

export const TODAY_STATS = {
  enquiries: 7,
  demosTriggered: 14,
  inDemo: 2,
  converted: 1,
  weekTarget: 8,
  weekConverted: 5,
};

export const COUNSELLOR = {
  name: "Anjali Rao",
  initials: "AR",
  role: "Senior Admissions Counsellor",
  school: "Soomuch Smart School",
  schoolMark: "SSS",
  schoolSub: "Hyderabad · Est. 1985",
};
